export interface IncidentHistoryWebComponentSchema {
  _id: string;
  type: number;
  created: string;
  incidentId: string;
  specifics: any;
}

export interface IncidentHistoryResults {
  data: Array<IncidentHistoryWebComponentSchema>;
  total: number;
}

export enum IncidentActions {
  CREATED = 1,
  UPDATED = 2,
  STATUS_CHANGED = 3,
  INCIDENT_ASSIGNED = 4,
  INCIDENT_UNASSIGNED = 5,
  PRIORITY_CHANGED = 6,
  NOTE_ADDED = 7,
  NODE_UPDATED = 8,
  NOTE_DELETED = 9,
}
